/* CRAVE VAULT — wishlist held on the device, shareable by link. */
(function () {
  'use strict';
  const KEY = 'zcrave.vault.v1';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ } };

  function paint() {
    const ids = read();
    document.querySelectorAll('[data-vault-toggle]').forEach((b) => {
      const on = ids.includes(b.dataset.vaultToggle);
      b.setAttribute('aria-pressed', String(on));
      b.textContent = on ? '♥' : '♡';
      b.setAttribute('aria-label', on ? 'Remove from Crave Vault' : 'Add to Crave Vault');
    });
    document.querySelectorAll('[data-vault-count]').forEach((el) => { el.textContent = ids.length; });
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-vault-toggle]');
    if (!b) return;
    e.preventDefault();
    const id = b.dataset.vaultToggle;
    const ids = read();
    const i = ids.indexOf(id);
    if (i === -1) ids.push(id); else ids.splice(i, 1);
    write(ids);
    paint();
    if (document.querySelector('[data-vault-list]')) render();
  });

  /* ---- the vault page ---- */
  async function render() {
    const list = document.querySelector('[data-vault-list]');
    if (!list) return;
    const ids = read();
    const empty = document.querySelector('[data-vault-empty]');
    if (!ids.length) { list.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    const cards = await Promise.all(ids.map(async (handle) => {
      try {
        const r = await fetch(`/products/${handle}?section_id=vault-card`);
        return r.ok ? await r.text() : '';
      } catch (e) { return ''; }
    }));
    list.innerHTML = cards.join('');
    paint();
  }

  /* ---- share ---- */
  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-vault-copy]')) {
      const url = `${location.origin}${location.pathname}?v=${encodeURIComponent(read().join(','))}`;
      try { await navigator.clipboard.writeText(url); e.target.textContent = 'COPIED'; }
      catch (err) { window.prompt('COPY YOUR VAULT LINK', url); }
    }
    if (e.target.closest('[data-vault-email]')) {
      const url = `${location.origin}${location.pathname}?v=${encodeURIComponent(read().join(','))}`;
      location.href = `mailto:?subject=${encodeURIComponent('MY CRAVE VAULT')}&body=${encodeURIComponent(url)}`;
    }
  });

  /* A shared link merges into whatever is already here. */
  const shared = new URLSearchParams(location.search).get('v');
  if (shared) {
    const incoming = shared.split(',').filter(Boolean);
    const merged = Array.from(new Set(read().concat(incoming)));
    write(merged);
  }

  paint();
  render();
})();
